import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { BiPaperPlane, BiCloudDownload } from "react-icons/bi";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import { collection, addDoc } from "firebase/firestore";
import { db } from "../api/firebaseConfig";

const generateInvoiceNumber = () => {
  return `INV-${Date.now()}`;
};

function GenerateInvoice() {
  html2canvas(document.querySelector("#invoiceCapture")).then((canvas) => {
    const imgData = canvas.toDataURL('image/png', 1.0);
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: [612, 792]
    });
    pdf.internal.scaleFactor = 1;
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('invoice-001.pdf');
  });
}


class InvoiceModal extends React.Component {
  constructor(props) {
    super(props);
  }
  async saveInvoiceRecord() {
    const invoiceData = {
      billFrom: this.props.info.billFrom,
      billFromAddress: this.props.info.billFromAddress,
      billFromEmail: this.props.info.billFromEmail,
      billTo: this.props.info.billTo,
      billToAddress: this.props.info.billToAddress,
      billToEmail: this.props.info.billToEmail,
      dateOfIssue: this.props.info.dateOfIssue,
      invoiceNumber: generateInvoiceNumber(),
      notes: this.props.info.notes || '',
      items: this.props.items,
      subTotal: this.props.subTotal,
      taxAmount: this.props.taxAmmount,
      discountAmount: this.props.discountAmmount,
      total: this.props.total,
      currency: this.props.currency,
      createdAt: new Date().toISOString()
    };

    const htmlTemp = (data) => {
      const {
        billFrom = '', billFromAddress = '', billFromEmail = '',
        billTo = '', billToAddress = '', billToEmail = '',
        invoiceNumber = '', dateOfIssue = '', notes = '', items = [],
        subTotal = 0, taxAmount = 0, discountAmount = 0, total = 0,
        currency = '₹'
      } = data;

      const dueDate = new Date(new Date(dateOfIssue).getTime() + 7 * 24 * 60 * 60 * 1000)
        .toLocaleDateString();

      const itemsHtml = items.map(item => `
    <tr>
      <td>${item.name || ''}</td>
      <td>${item.description || ''}</td>
      <td>${item.quantity || 0}</td>
      <td>${currency}${Number(item.price || 0).toFixed(2)}</td>
      <td>${currency}${Number(item.total || 0).toFixed(2)}</td>
    </tr>
  `).join('');

      return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Invoice #${invoiceNumber}</title>
  <style>
    body {
      margin: 0;
      padding: 20px;
      font-family: Arial, sans-serif;
      font-size: 13px;
      background: #fff;
      color: #333;
    }

    .invoice-box {
      max-width: 700px;
      margin: auto;
      border: 1px solid #eee;
      padding: 20px 30px;
      border-radius: 8px;
    }

    h1 {
      font-size: 20px;
      color: #444;
      margin-bottom: 10px;
    }

    .meta, .section {
      margin-bottom: 20px;
    }

    .section h4 {
      font-size: 13px;
      margin-bottom: 4px;
      color: #111;
    }

    .section p {
      margin: 0;
      line-height: 1.4;
    }

    .meta {
      display: flex;
      justify-content: space-between;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
    }

    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }

    th {
      background: #f4f4f4;
      font-weight: bold;
    }

    .totals {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    .totals table {
      width: 280px;
    }

    .totals td {
      padding: 6px;
      font-size: 13px;
    }

    .totals tr:last-child td {
      font-weight: bold;
      font-size: 14px;
      border-top: 2px solid #ccc;
    }

    .notes {
      margin-top: 30px;
      font-style: italic;
      color: #666;
    }

    @media print {
      body {
        background: white;
      }
      .invoice-box {
        border: none;
        padding: 0;
      }
    }
  </style>
</head>
<body>
  <div class="invoice-box">
    <div class="meta">
      <div>
        <h1>Invoice</h1>
        <p><strong>#${invoiceNumber}</strong></p>
      </div>
      <div>
        <p><strong>Issue Date:</strong> ${dateOfIssue}</p>
        <p><strong>Due Date:</strong> ${dueDate}</p>
      </div>
    </div>

    <div class="section">
      <h4>From:</h4>
      <p>${billFrom}</p>
      <p>${billFromAddress}</p>
      <p>${billFromEmail}</p>
    </div>

    <div class="section">
      <h4>To:</h4>
      <p>${billTo}</p>
      <p>${billToAddress}</p>
      <p>${billToEmail}</p>
    </div>

    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Unit Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        ${itemsHtml}
      </tbody>
    </table>

    <div class="totals">
      <table>
        <tr>
          <td>Subtotal:</td>
          <td>${currency}${Number(subTotal).toFixed(2)}</td>
        </tr>
        <tr>
          <td>Tax:</td>
          <td>${currency}${Number(taxAmount).toFixed(2)}</td>
        </tr>
        <tr>
          <td>Discount:</td>
          <td>- ${currency}${Number(discountAmount).toFixed(2)}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${currency}${Number(total).toFixed(2)}</td>
        </tr>
      </table>
    </div>

    <div class="notes">
      <p>${notes || ''}</p>
    </div>
  </div>
</body>
</html>`;
    };



    try {
      const docRef = await addDoc(collection(db, "invoices"), invoiceData);
      console.log("Invoice saved with ID: ", docRef.id);
      alert("Email Send and Record Saved!");

      const invoiceHtml = htmlTemp(invoiceData);

      const url = `https://carenest.ancientcoders.in/sendEmail?t=${encodeURIComponent(invoiceData.billToEmail)}&s=${encodeURIComponent(`Invoice from ${invoiceData.billFrom}`)}&temp=${encodeURIComponent(invoiceHtml)}`;

      const response = await fetch(url);
      if (response.status == 400) throw new Error("Failed to send email");
      const result = await response.json();
      console.log("✅ Email sent:", result);
    } catch (error) {
      console.error("Error saving or emailing invoice: ", error);
    }
  }

  render() {
    return (
      <div>
        <Modal show={this.props.showModal} onHide={this.props.closeModal} size="lg" centered>
          <div id="invoiceCapture">
            <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
              <div className="w-100">
                <h4 className="fw-bold my-2">{this.props.info.billFrom || 'Aniket Pardeshi'}</h4>
                <h6 className="fw-bold text-secondary mb-1">
                  Invoice #: {this.props.info.invoiceNumber || ''}
                </h6>
              </div>
              <div className="text-end ms-4">
                <h6 className="fw-bold mt-1 mb-2">Amount&nbsp;Due:</h6>
                <h5 className="fw-bold text-secondary"> {this.props.currency} {this.props.total}</h5>
              </div>
            </div>
            <div className="p-4">
              <Row className="mb-4">
                <Col md={4}>
                  <div className="fw-bold">Billed to:</div>
                  <div>{this.props.info.billTo || ''}</div>
                  <div>{this.props.info.billToAddress || ''}</div>
                  <div>{this.props.info.billToEmail || ''}</div>
                </Col>
                <Col md={4}>
                  <div className="fw-bold">Billed From:</div>
                  <div>{this.props.info.billFrom || ''}</div>
                  <div>{this.props.info.billFromAddress || ''}</div>
                  <div>{this.props.info.billFromEmail || ''}</div>
                </Col>
                <Col md={4}>
                  <div className="fw-bold mt-2">Date Of Issue:</div>
                  <div>{this.props.info.dateOfIssue || ''}</div>
                </Col>
              </Row>
              <Table className="mb-0">
                <thead>
                  <tr>
                    <th>QTY</th>
                    <th>DESCRIPTION</th>
                    <th className="text-end">PRICE</th>
                    <th className="text-end">AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.items.map((item, i) => {
                    return (
                      <tr id={i} key={i}>
                        <td style={{ width: '70px' }}>
                          {item.quantity}
                        </td>
                        <td>
                          {item.name} - {item.description}
                        </td>
                        <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {item.price}</td>
                        <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {item.price * item.quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <Table>
                <tbody>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className="text-end">
                    <td></td>
                    <td className="fw-bold" style={{ width: '100px' }}>SUBTOTAL</td>
                    <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {this.props.subTotal}</td>
                  </tr>
                  {this.props.taxAmmount != 0.00 &&
                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" style={{ width: '100px' }}>TAX</td>
                      <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {this.props.taxAmmount}</td>
                    </tr>
                  }
                  {this.props.discountAmmount != 0.00 &&
                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" style={{ width: '100px' }}>DISCOUNT</td>
                      <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {this.props.discountAmmount}</td>
                    </tr>
                  }
                  <tr className="text-end">
                    <td></td>
                    <td className="fw-bold" style={{ width: '100px' }}>TOTAL</td>
                    <td className="text-end" style={{ width: '100px' }}>{this.props.currency} {this.props.total}</td>
                  </tr>
                </tbody>
              </Table>
              {this.props.info.notes &&
                <div className="bg-light py-3 px-4 rounded">
                  {this.props.info.notes}
                </div>}
            </div>
          </div>
          <div className="pb-4 px-4">
            <Row>
              <Col md={6}>
                <Button variant="primary" className="d-block w-100" onClick={() => {
                  this.saveInvoiceRecord();
                }}>
                  <BiPaperPlane style={{ width: '15px', height: '15px', marginTop: '-3px' }} className="me-2" />Send Invoice
                </Button>
              </Col>
              <Col md={6}>
                <Button variant="outline-primary" className="d-block w-100 mt-3 mt-md-0" onClick={GenerateInvoice}>
                  <BiCloudDownload style={{ width: '16px', height: '16px', marginTop: '-3px' }} className="me-2" />
                  Download Copy
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
        <hr className="mt-4 mb-3" />
      </div>
    )
  }
}

export default InvoiceModal;
